
import * as domainRegex from 'domain-regex'
export default {
  email: /^[^@\s]+@[^@\s]+\.[^@\s]+$/,
  phone: /^\(\d{3}\)\s\d{3}-\d{4}$/,
  uid: /^[a-z][a-z0-9-_]{2,47}$/,
  dob: /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/,
  zip: /^\d{5}$/,
  state: /^[A-Z]{2}$/,
  city: /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/,
  domain: domainRegex.default(),
  name: /^[a-zA-Z\s]+$/,
  firstAndLast: /^[a-zA-Z]+ [a-zA-Z]+$/,
  all: /\.*/
}



// WEBPACK FOOTER //
// ./src/lib/regex.js